import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import DraftsIcon from "@mui/icons-material/Drafts";
import React from "react";
import Loading from "components/Common/Loading";

interface Props {
  isLoading?: boolean;
  totalSent: number;
  success: number;
  failed: number;
}

const MessageStatistics: React.FC<Props> = ({
  isLoading,
  totalSent,
  success,
  failed,
}) => {
  return (
    <Box sx={{ width: isLoading ? "100%" : "fit-content", minHeight: 148 }}>
      {isLoading ? (
        <Box
          sx={{
            minHeight: 148,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading />
        </Box>
      ) : (
        <Card variant="outlined" sx={{ minWidth: 280, borderRadius: 1 }}>
          <CardContent sx={{ px: 2, py: 1, "&:last-child": { pb: 1 } }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 1,
              }}
            >
              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontWeight="medium"
                >
                  Total Sent
                </Typography>
                <Typography variant="h4" fontWeight="bold" sx={{ mt: 0.5 }}>
                  {totalSent}
                </Typography>
              </Box>
              <DraftsIcon sx={{ color: "text.secondary", fontSize: 28 }} />
            </Box>

            <Grid container>
              <Grid item xs={6}>
                <Typography variant="h6" fontWeight="bold">
                  {success}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Success Sent
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h6" fontWeight="bold">
                  {failed}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Failed Sent
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default React.memo(MessageStatistics);
